<template>
  <iframe
    :src="src"
    frameborder="0"
    width="100%"
    style="height: 100vh;"
  ></iframe>
</template>
<script>
const originUrl = {
  production: location.origin,
  development: location.origin,
  release: location.origin,
  test: 'https://ump.ems.com.cn'
}
const url = {
  production: '/newmail-api/expandMenu/introduce/index.html#/',
  release: '/newmail-release/expandMenu/introduce/index.html#/'
}

const dir = {
  test: {
    charge: url['release'] + 'deliveryRule',
    product: url['release'] + 'product',
    zhongsuhuoyun:
      url['release'] +
      'productDetail?activate=国际业务&productName=中速快运（货运类）',
    zhongyouhaiwaicang:
      url['release'] + 'productDetail?activate=国际业务&productName=中邮海外仓',
    zhongyoufba:
      url['release'] + 'productDetail?activate=国际业务&productName=中邮FBA'
  },
  release: {
    charge: url['release'] + 'deliveryRule',
    product: url['release'] + 'product',
    zhongsuhuoyun:
      url['release'] +
      'productDetail?activate=国际业务&productName=中速快运（货运类）',
    zhongyouhaiwaicang:
      url['release'] + 'productDetail?activate=国际业务&productName=中邮海外仓',
    zhongyoufba:
      url['release'] + 'productDetail?activate=国际业务&productName=中邮FBA'
  },
  production: {
    charge: url['production'] + 'deliveryRule',
    product: url['production'] + 'product',
    zhongsuhuoyun:
      url['production'] +
      'productDetail?activate=国际业务&productName=中速快运（货运类）',
    zhongyouhaiwaicang:
      url['production'] +
      'productDetail?activate=国际业务&productName=中邮海外仓',
    zhongyoufba:
      url['production'] + 'productDetail?activate=国际业务&productName=中邮FBA'
  }
}
const NODE_ENV = process.env.VUE_APP_NODE_ENV
export default {
  name: 'introducePagev2',
  data () {
    return {
      src: `${this.urlConfig(this.$route.query.type)}`
    }
  },
  watch: {
    '$route.query': function (newVal, oldVal) {
      this.src = `${this.urlConfig(this.$route.query.type)}`
    }
  },
  methods: {
    urlConfig (type) {
      const env = NODE_ENV === 'development' ? 'test' : NODE_ENV
      let url = `${originUrl[env]}${dir[env][type]}`
      if (url.includes('?')) {
        url += `&active=${this.$route.query.active}&t=${Date.now()}`
      } else {
        url += `?active=${this.$route.query.active}&t=${Date.now()}`
      }
      return url
    }
  }
}
</script>
<style lang="scss" scoped></style>
